import { render, staticRenderFns } from "./Robot.vue?vue&type=template&id=086c2382&scoped=true&"
var script = {}
import style0 from "./Robot.vue?vue&type=style&index=0&id=086c2382&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086c2382",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/hanzhu/nutstore-webpages/js_src_vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('086c2382')) {
      api.createRecord('086c2382', component.options)
    } else {
      api.reload('086c2382', component.options)
    }
    module.hot.accept("./Robot.vue?vue&type=template&id=086c2382&scoped=true&", function () {
      api.rerender('086c2382', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/FloatComponents/Robot.vue"
export default component.exports